/* eslint-disable react/display-name */
import * as React from 'react';

const Location = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g id="Mask">
      <path
        d="M4,7.07,7.73,8A.42.42,0,0,1,8,8.27L8.93,12,13.1,2.9ZM6.61,9.39.42,7.91a.55.55,0,0,1-.1-1L15.22.05A.55.55,0,0,1,16,.78L9.12,15.68a.55.55,0,0,1-1-.1Z"
        style={{ fill: 'inherit' }}
      />
    </g>
  </svg>
);

export default Location;
